<template>
  <div
    class="comment-card"
    :class="{'pointer': !showButton}"
    data-qa="comment-card"
    @click="showButton ? null : $emit('openChat', item.organizationId)">
    <sBadge
      class="width-100 comment-card-org-title"
      color="red"
      :content="item.needBadge"
      data-qa="comment-block-badge"
      dot
      overlap
      :value="item.needBadge">
      {{ item.organizationTitle }}
    </sBadge>
    <div
      class="comment-card-date"
      data-qa="comment-card-date">
      {{ $d(new Date(item.lastDateQuestion), 'longDate') }}
    </div>
    <div
      class="comment-card-message"
      data-qa="comment-card-message">
      {{ item.questions[item.questions.length - 1].question.message }}
    </div>
    <div
      v-if="showButton"
      class="text-right">
      <sButton
        data-qa="comment-card-button"
        small
        type="text"
        @click="$emit('openChat', item.organizationId)">
        {{ textButton || $t('Common.OpenChat') }}
      </sButton>
    </div>
  </div>
</template>
<script>
/**
 * Карточка организации участника в обращениях
 */
export default {
  name: 'commentCard',
  props: {
    /**
     * Данные
     */
    item: {
      type: Object,
      require: true
    },
    /**
     * Признак отображения кнопки открытия чата
     */
    showButton: {
      type: Boolean,
      default: true
    },
    /**
     * Текст на кнопке открытия чата
     */
    textButton: {
      type: String
    },
    mode: {
      type: String,
      default: 'comment'
    }
  },
  computed: {
    convertItem() {
      if (this.mode === 'comment') {
        return this.item
      }
      return {
        organizationId: null,
        needBadge: null,
        organizationTitle: null,
        lastDateQuestion: null,
        questions: [
          {
            question: {
              message: null,
            }
          }
        ]
      }
    }
  }
}
</script>
<style scoped>
.comment-card {
  padding: 10px 10px 10px 20px;
  text-align: left;
  background: var(--v-secondary__green_chosen-base);
  border-radius: 8px;
  margin-bottom: 10px;
  font-weight: 500;
}
.comment-card-org-title {
  font-weight: 600;
  line-height: 18px;
  text-decoration: underline;
}
.comment-card-date {
  font-size: 12px;
  line-height: 16px;
  opacity: 0.5;
}
.comment-card-message {
  margin-top: 4px;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 5px;
  white-space: pre-line;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
}
</style>
